import styled from '@emotion/styled'
import React from 'react'
import { Button, Tooltip } from 'aa_common/front-end/antd'
import { Card as AntCard, Collapse as AntCollapse } from 'antd'
import { Link } from 'react-router-dom'
import { RightDrawer } from 'aa_common/front-end/components'

export const preLineStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'pre-line',
}

export const Wrapper = styled.div`
  width: 950px;
`

export const Error = styled.div`
  color: #dc3545;
`

export const Heading = styled.div`
  display: flex;
  margin-left: 10px;
  margin-top: 15px;
  align-items: center;
`

export const HeadingTitle = styled.span`
  font-size: 20px;
  font-weight: 700;
  margin-right: 10px;
`

export const BottomSubmit = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  z-index: 10;
  border-top: 1px #d4d8dd solid;
`

export const SavedAtNotice = styled.label`
  color: #333333;
  margin-left: 10px;
  font-size: 13px;
`

export const FormGroup = styled.div`
  &:after {
    display: table;
    content: '';
    clear: both;
  }
`

export const UnderlineInputWrapper = styled.div`
  display: contents;
  height: 32px;
  display: flex;
  position: relative;

  input,
  label.value-view {
    border: none;
    border-bottom: 1px solid #d4d8dd;
    box-sizing: border-box;
    width: 100%;
    padding: 7px;
    padding-right: 18px;
    font-size: 13px;
    color: #7c8291;
    background: none;

    &:focus {
      outline: 0;
    }
  }

  .edit-icon {
    position: absolute;
    top: 10px;
    right: 0px;
    color: #7c8291;
    cursor: pointer;
  }

  .reset-link {
    position: absolute;
    top: 6px;
    right: 0px;
    color: #3b7de9;
    cursor: pointer;
  }
`

export const TopMessage = styled.div`
  background-color: #ffffff;
  padding: 10px;
  border: 1px solid #d4d8dd;
  white-space: pre-wrap;
`

export const BottomMessage = styled.div`
  margin: 15px 10px;
  color: #7c8291;
  font-size: 12px;

  .delete {
    font-size: 13px;
    color: #ec4949;
    cursor: pointer;
  }

  .disabled {
    font-size: 13px;
    color: #7c8291;
    opacity: 0.3;
  }
`

export const AssetCodeWrapper = styled.div`
  display: flex;
`

export const LedgerHeader = styled.div`
  display: inline-flex;
  margin-left: 10px;
  margin-bottom: 15px;
`

export const TitleName = styled.span`
  color: rgb(51, 51, 51);
  font-size: 16px;
  font-weight: 700;
  margin-right: 10px;
`

export const ErrorMessage = styled.div`
  box-sizing: border-box;
  color: #ec4949;
  border-radius: 4px;
  border: 2px solid #f57575;
  background: #ffeeeb;
  padding: 15px;
  font-size: 14px;
`

export const prelineStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'pre-line',
}

export const StyledTooltip = styled(Tooltip)`
  display: inline-block;

  .adjusted {
    color: #0000003f;
    cursor: not-allowed;
  }
`

export const AskAIAssistantButton = styled(Button)`
  margin-top: 10px;
`

export const AIFormContentWrapper = styled.div`
  margin-top: 16px;
`

const aiCardBorder = '#91caff'
const aiCardPrimary = '#3b7de9'

export const Card = styled(AntCard)`
  margin: 16px 0;
  border-radius: 16px;
  border: 2px solid ${aiCardBorder};
  background: #eef5ff;

  .ant-card-body {
    padding: 20px;
  }

  .ant-typography {
    margin: 4px 0;
    font-size: 18px;
  }

  .ant-typography + h5.ant-typography {
    margin: 4px 0;
    font-size: 16px;
  }

  .disclaimer,
  .multiple-suggestion-notice {
    span.ant-typography {
      font-size: 12px;
      margin: 0;
    }
  }

  .multiple-suggestion-notice {
    margin-bottom: 24px;

    h5.ant-typography {
      font-size: 14px;
      margin: 0;
    }
  }
`

export const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${aiCardPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CardContent = styled(AntCard)`
  border-radius: 12px;
  border: 2px solid ${aiCardBorder};
  margin-bottom: 16px;
  background: #fff;
  transition: 0.3s;

  .ant-typography.ant-typography-secondary {
    font-size: 12px;
  }

  &:hover {
    cursor: pointer;
    border-color: ${aiCardPrimary};
    box-shadow: 0 0 0 1px ${aiCardPrimary};
  }

  &.selected {
    border-color: ${aiCardPrimary};
    background: #ecf4ff;
    box-shadow: 0 0 0 1px ${aiCardPrimary};

    .ant-collapse-content-box {
      background: #ecf4ff;
      border-radius: 12px;

      .ant-typography {
        display: block;

        &:is(:first-child) {
          margin-top: 0;
        }
      }
    }
  }
`

export const Collapse = styled(AntCollapse)`
  margin-bottom: 12px;
  border: none;
  background: none;

  .ant-collapse-item {
    border: none;

    .ant-collapse-header {
      padding: 10px 0;
    }

    & > .ant-collapse-content {
      border-radius: 12px;
      border: 1px solid ${aiCardBorder};
    }

    .ant-typography {
      font-size: 14px;
      display: block;

      &:is(:first-child) {
        margin-top: 0;
      }
    }
  }
`

export const RegisterInMaster = styled(Link)`
  color: ${aiCardPrimary};
`

export const Warning = styled.div`
  margin-top: 10px;
  padding: 10px;
  background: #fff8de;
  border: 2px solid #ffd666;
  border-radius: 12px;
  font-size: 13px;

  .ant-typography {
    color: #863816;
    font-weight: 500;
    font-size: 13px;
  }
`

export const AssetCategoryDropdownFooterWrapper = styled.div`
  width: 100%;

  span {
    text-align: right;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
  }
`

export const ModalContent = styled.div`
  padding: 0 15px 15px;

  .ant-typography {
    margin: 8px 0;
  }

  a.ant-typography {
    color: ${aiCardPrimary};
  }

  .ant-checkbox-wrapper {
    font-size: 13px;
  }
`

export const NoResultWrapper = styled.div`
  margin: 20px 0;

  .icon {
    color: #00000073;
    font-size: 40px;
    opacity: 0.8;
  }

  .ant-btn {
    display: block;
    margin-top: 16px;
    margin-left: auto;
    width: 200px;
  }
`

export const TopSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;

  .ant-typography {
    &:first-child {
      font-weight: 500;
      font-size: 16px;
    }
  }
`

export const Troubleshooting = styled.div`
  background: #0000000f;
  padding: 16px;
  border-radius: 12px;
  margin-top: 30px;

  ul {
    list-style: none;
    padding-left: 0;

    li {
      position: relative;
      padding-left: 28px;

      &::before {
        content: '・';
        position: absolute;
        left: 0;
        top: 0;
        color: #00000073;
      }
    }
  }

  .example {
    color: #00000073;
  }
`

export const NoticeWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #d2d2d2;
  background: #f8f8f8;
  font-size: 12px;
  margin-top: 24px;

  .fa-circle-info,
  .fa-list {
    font-size: 18px;
    margin-top: 5px;
    color: #7c8291;
  }
`

export const ImageWrapper = styled.div`
  margin-top: 12px;
  text-align: center;
  position: relative;
  display: inline-block;

  .ant-image {
    object-fit: contain;
  }

  .fa-circle-xmark {
    position: absolute;
    top: -7px;
    right: -7px;
    font-size: 18px;
    color: #8c8c8c;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    border: 1px solid #d4d8dd;
  }
`

export const StyledRightDrawer = styled(RightDrawer)`
  .ant-drawer-body {
    position: relative;
  }
`

export const AIDisclaimerWrapper = styled.div`
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
`
